export default function SaveFiltersModalController(
  $scope,
  usersService,
  $timeout,
  $filter,
  $uibModal,
  $uibModalInstance,
  $state,
  gettextCatalog,
  filterModels,
  selectedTags,
  tagFilters,
  savedFilterService,
) {
  'ngInject';

  const vm = this;

  // private variable
  const savedFiltersKeys = {
    lastCommKey: 'lastCommunicated',
    lastSeenKey: 'lastSeen',
  };

  const userId = usersService.currentUser().id;

  // Build payload for adding/updating filter
  const buildPayload = (savedFilter = null) => {
    // Reset the savedFilters model before creating
    if (savedFilter === null) {
      vm.savedFilters = newSavedFilter();
      // Build savedFilters Model
      vm.savedFilters.name = $scope.filters.name;
      vm.savedFilters.description = $scope.filters.description;
      vm.savedFilters.userId = userId; // userId is coming from userService.currentUser.id
    } else {
      vm.savedFilters = {
        id: savedFilter.id,
        securityGroupIds: [],
        alertStates: [],
        maintenanceStates: [],
        attrValueList: {},
        filtersCollection: {},
        queryString: '',
      };
    }

    vm.savedFilters.queryString = filterModels.queryString;

    if (filterModels.securityGroups && filterModels.securityGroups.length > 0) {
      _.forEach(filterModels.securityGroups, function (fs) {
        vm.savedFilters.securityGroupIds.push(fs.tag);
      });
    }
    if (filterModels.alerts && filterModels.alerts.length > 0) {
      _.forEach(filterModels.alerts, function (fa) {
        vm.savedFilters.alertStates.push(fa.tag);
      });
    }
    if (filterModels.maintenance && filterModels.maintenance.length > 0) {
      _.forEach(filterModels.maintenance, function (fm) {
        vm.savedFilters.maintenanceStates.push(fm.tag);
      });
    }

    if (filterModels.lastCommunicated && filterModels.lastCommunicated.length > 0) {
      vm.savedFilters.filtersCollection[savedFiltersKeys.lastCommKey] =
        filterModels.lastCommunicated[0];
    }

    if (filterModels.lastSeen && filterModels.lastSeen.length > 0) {
      vm.savedFilters.filtersCollection[savedFiltersKeys.lastSeenKey] = filterModels.lastSeen[0];
    }

    if (selectedTags && selectedTags.length > 0) {
      for (var i = 0; i < selectedTags.length; i++) {
        _.forEach($scope.tagFilters, function (tf) {
          if (tf[selectedTags[i].key]) {
            const Values = angular.copy(tf[selectedTags[i].key]);
            if (selectedTags[i].dataType === 'Datetime') {
              if (Values.min) {
                const tempMin = Values.min.replace(/\\/g, '').toUpperCase();
                Values.min = new Date(tempMin);
              }
              if (Values.max) {
                const tempMax = Values.max.replace(/\\/g, '').toUpperCase();
                Values.max = new Date(tempMax);
              }
            }
            vm.savedFilters.attrValueList[selectedTags[i].id] = Values;
          }
        });
      }
    }
  };

  $scope.savedFiltersModels = []; // full list of saved search filters
  $scope.savedFiltersModelByPage = [];
  $scope.selectedSavedFilterId = '';
  $scope.filteredSavedFilters = [];
  $scope.selectedFilters = {};
  $scope.search = {
    text: '',
  };
  $scope.isPaging = false;
  $scope.loading = false;
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.tagFilters = [];
  $scope.tagFilters.push(tagFilters);
  $scope.filters = {
    name: '',
    description: '',
  };

  vm.savedFilters = newSavedFilter();

  // Pagination
  $scope.current = {
    savedFiltersPage: 1,
  };
  $scope.itemsPerPage = 3;
  $scope.maxSize = 1;

  $scope.showPaging = function () {
    $scope.isPaging = true;
    $scope.errorFlag = false;
  };

  $scope.hidePaging = function () {
    $scope.isPaging = false;
    $scope.errorFlag = false;
  };

  // Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;

  // Sort filteredSavedFilters
  $scope.orderBy = function (predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;
  };

  // savedFilters per page
  $scope.displaySavedFiltersByPage = function () {
    $scope.totalItems = $scope.filteredSavedFilters.length;
    const begin = ($scope.current.savedFiltersPage - 1) * $scope.itemsPerPage;
    const end = begin + $scope.itemsPerPage;
    $scope.savedFiltersModelByPage = $scope.filteredSavedFilters.slice(begin, end);
  };

  // applyFilter searchs on savedFiltersModels[] for anything matching the search input.
  $scope.applyFilter = function () {
    $scope.filteredSavedFilters = $filter('filter')($scope.savedFiltersModels, $scope.search.text);
    $scope.displaySavedFiltersByPage();
  };

  // on selected page changed
  $scope.pageChanged = function () {
    $scope.displaySavedFiltersByPage();
  };

  // called after change happend to savedFiltersModels to update the table
  $scope.updateFiltersList = function () {
    $scope.filteredSavedFilters = $scope.savedFiltersModels.slice();
    $scope.displaySavedFiltersByPage();
  };
  // clear the conflict message when user changes the name field
  $scope.$watch('savedFiltersName', function (newVal, oldVal) {
    // compare
    if (newVal !== oldVal) {
      $scope.errorFlag = false;
    }
  });

  // watch search then apply it
  $scope.$watch('search.text', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.applyFilter();
    }
  });

  // watch savedFiltersModels then create model with remove flags
  $scope.$watch('savedFiltersModels', function () {
    $scope.updateFiltersList();
  });

  // saved filter model
  function newSavedFilter() {
    const model = {
      name: '',
      description: '',
      userId: '',
      securityGroupIds: [],
      alertStates: [],
      maintenanceStates: [],
      attrValueList: {},
      filtersCollection: {},
      queryString: '',
    };
    return model;
  }

  // Saved Search Filters
  $scope.getSavedFilters = function () {
    $scope.loading = true;
    savedFilterService
      .getAllSavedFilters(userId)
      .then(function (response) {
        $scope.savedFiltersModels = response.data.reverse();
        $scope.loading = false;
      })
      .catch(function (error) {
        let errorMsg = gettextCatalog.getString(
          'An error occurred while retrieving Saved Filter information. Please try again later.',
        );
        if (error) {
          if (!!error.data && !!error.data.message && !!error.status && !!error.statusText) {
            errorMsg = `${
              error.data.message
            } ${error.status.toString()} - ${error.statusText.toString()}`;
          } else if (!!error.status && !!error.statusText) {
            errorMsg = `${gettextCatalog.getString(
              'An error occurred while retrieving Saved Filter information: ',
            )}${error.status.toString()} - ${error.statusText.toString()}`;
          }
        }
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
      })
      .finally(function () {
        $scope.loading = false;
      });
  }; // getSavedFilters

  $scope.getSavedFilters();

  // Validate the form on submission then run the API call
  $scope.isFormValid = function (saveFiltersForm) {
    saveFiltersForm.$setSubmitted();
    if (saveFiltersForm.$invalid) {
      $scope.loading = false;
    } else {
      $scope.save();
    }
  };

  $scope.createSavedFilter = function () {
    buildPayload();

    $scope.submitSavedFilters();
  };

  $scope.patchSavedFilters = function (savedFilter) {
    buildPayload(savedFilter);

    $scope.saveAsExistingFilter(vm.savedFilters);
  };

  function NameExists() {
    return (
      $scope.savedFiltersModels.filter((filter) => filter.name === $scope.filters.name).length !== 0
    );
  }

  $scope.submitSavedFilters = function () {
    const nameExistError = gettextCatalog.getString(
      'The name already exists. Please rename the Saved Filter.',
    );

    if (NameExists()) {
      $scope.errorFlag = true;
      $scope.errorText = nameExistError;
      return;
    }

    $scope.loading = true;
    $scope.error = null;
    const savedFilter = vm.savedFilters;
    if (savedFilter) {
      savedFilterService
        .postSaveFilter(savedFilter)
        .then(function () {
          return $timeout(function () {
            $scope.close();
          }, 3000);
        })
        .catch(function (error) {
          if (error.status === 409) {
            $scope.errorFlag = true;
            $scope.errorText = nameExistError;
          } else {
            let errorMsg = gettextCatalog.getString(
              'An error occurred while saving Saved Filter information. Please try again later.',
            );
            if (error) {
              if (!!error.data && !!error.data.message && !!error.status && !!error.statusText) {
                errorMsg = `${
                  error.data.message
                } ${error.status.toString()} - ${error.statusText.toString()}`;
              } else if (!!error.status && !!error.statusText) {
                errorMsg = `${gettextCatalog.getString(
                  'An error occurred while saving Saved Filter information: ',
                )}${error.status.toString()} - ${error.statusText.toString()}`;
              }
            }
            $scope.errorFlag = true;
            $scope.errorText = errorMsg;
          }
        })
        .finally(function () {
          $scope.loading = false;
        });
    }
  };

  $scope.saveAsExistingFilter = function (savedFilter) {
    if (savedFilter) {
      // $scope.savedFiltersModels = [];
      const modalInstance = $uibModal.open({
        animation: true,
        template: require('./save-filters-confirm-modal.html'),
        controller: 'SaveFiltersConfirmModalController',
        resolve: {
          savedFilter() {
            return savedFilter;
          },
        },
        size: 'md',
      });

      // modal dialog result
      modalInstance.result.then(
        function (savedFiltersModels) {
          $scope.savedFiltersModels = savedFiltersModels;
        },
        function () {},
      );
    } else {
      $uibModalInstance.dismiss();
    }
  };

  $scope.save = function () {
    $scope.createSavedFilter();
  };

  $scope.close = function () {
    $uibModalInstance.close(vm.savedFilters);
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss();
  };

  $scope.$on('$locationChangeStart', function (event) {
    $scope.cancel();
    event.preventDefault();
  });
}
